"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatorsSchema = void 0;
const zod_1 = require("zod");
const calculator_schema_1 = require("./calculator.schema");
exports.calculatorsSchema = zod_1.z.array(calculator_schema_1.calculatorSchema).describe("List of calculators");
